import { Badge, UncontrolledTooltip } from "reactstrap";
import { Btn } from "../../../AbstractElements";

export const getAdministratorColumns = (
  columnHelper,
  handleEdit,
  handleEditPwd
) => [
    columnHelper.accessor("name", {
      header: "Nombre",
      cell: (info) => <strong>{info.getValue()}</strong>,
    }),

    columnHelper.accessor("email", {
      header: "Correo",
      cell: (info) => <span>{info.getValue()}</span>,
    }),

    columnHelper.display({
      id: "estado",
      header: "Estado",
      cell: (props) => {
        const state = props.row.original.state;
        return (
          <Badge color={state ? "success" : "danger"}>
            {state ? "Activo" : "Inactivo"}
          </Badge>
        );
      },
    }),

    columnHelper.display({
      id: "role",
      header: "Rol",
      cell: (props) => {
        const role = props.row.original.role;
        const mapping = { ADMIN: "Administrador", ADMIN_ASSISTANT: "Auxiliar Administrativo", ASSISTANT: "Auxiliar" };
        return <Badge color="secondary">{mapping[role] ?? role}</Badge>;
      },
    }),

    columnHelper.display({
      id: "acciones",
      header: "Acciones",
      cell: (props) => {
        const admin = props.row.original;
        const editId = `edit-btn-${admin.id}`;
        const passId = `pass-btn-${admin.id}`;

        return (
          <div className="d-flex gap-1">
            {/* Editar datos */}
            <Btn
              attrBtn={{
                color: "primary",
                size: "sm",
                id: editId,
                onClick: () => handleEdit(admin),
              }}
            >
              <i className="fa fa-edit" />
            </Btn>
            <UncontrolledTooltip target={editId}>Editar</UncontrolledTooltip>

            {/* Cambiar contraseña */}
            <Btn
              attrBtn={{
                color: "warning",
                size: "sm",
                id: passId,
                onClick: () => handleEditPwd(admin),
              }}
            >
              <i className="fa fa-key" />
            </Btn>
            <UncontrolledTooltip target={passId}>
              Cambiar contraseña
            </UncontrolledTooltip>
          </div>
        );
      },
    }),
  ];
